import { render } from "./SafePaymentIcon.vue?vue&type=template&id=8011b07e&scoped=true"
import script from "./SafePaymentIcon.vue?vue&type=script&lang=js"
export * from "./SafePaymentIcon.vue?vue&type=script&lang=js"

import "./SafePaymentIcon.vue?vue&type=style&index=0&id=8011b07e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8011b07e"]])

export default __exports__